import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  Container,
  CssBaseline,
  useTheme
} from '@mui/material';
import { useTranslation } from '../utils/translations';

const Login = ({ onLogin, language }) => {
  const t = useTranslation(language);
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));

    // Dummy authentication - accept any non-empty credentials
    if (username.trim() && password.trim()) {
      onLogin({
        username: username.trim(),
        role: 'admin', // You can customize this
        timestamp: new Date().toISOString()
      });
    } else {
      setError(t('enterUsernamePassword'));
    }
    
    setLoading(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: isDarkMode ? '#1a1a1a' : '#fafafa'
        }}
      >
        <Card sx={{ 
          width: '100%', 
          maxWidth: 420,
          backgroundColor: isDarkMode ? '#373737' : '#ffffff'
        }}>
          <CardContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 2 }}>
              <img
                src={isDarkMode ? "/logos/logo_dark_mode.png" : "/logos/logo_light.png"}
                alt="Login Logo"
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  height: 'auto',
                  marginBottom: '8px',
                  display: 'block'
                }}
              />
            </Box>
            <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label={t('username')}
                name="username"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                disabled={loading}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label={t('password')}
                type="password"
                id="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
              />
              {error && (
                <Alert 
                  severity="error" 
                  sx={{ 
                    mt: 2,
                    '& .MuiAlert-icon': {
                      color: '#D03A22'
                    },
                    borderColor: '#D03A22',
                    backgroundColor: 'rgba(208, 58, 34, 0.1)',
                    color: '#D03A22'
                  }}
                >
                  {error}
                </Alert>
              )}
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                {loading ? t('signingIn') : t('signIn')}
              </Button>
            </Box>
          </CardContent>
        </Card>
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            {t('demoLogin')}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {t('suggested')}
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default Login; 